import UnsentMail from '../unsentMail';

export default function UnsentMailPage() {
  return (
    <UnsentMail />
  );
}
